export const LOCATION_LIST_FETCH_LIMIT = 1000;
export const LOCATION_OPTIONS_PAGE_SIZE = 100;
// Matches the backend invoice and contract page size (BILLING_PAGE_SIZE, CONTRACT_PAGE_SIZE).
export const BILLING_LIST_PAGE_SIZE = 20;
// Matches the backend inventory page size (INVENTORY_PAGE_SIZE).
export const LOGISTICS_INVENTORY_PAGE_SIZE = 50;
